import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation DeleteCustomFormula($id: ID!) {
    deleteCustomFormula(id: $id) {
      id
    }
  }
`;

export const deleteCustomFormula = (id) => {
  const variables = {
    id,
  };

  return executeGqlMutation({
    mutation: MUTATION,
    variables,
  }).then(({ data }) => getSingleProp(data));
};
